// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/footer/Footer.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/footer/Footer.tsx");
  import.meta.hot.lastModified = "1748278914638.2078";
}
// REMIX HMR END

import { Link } from '@remix-run/react';
import { useTranslation } from 'react-i18next';
import { Instagram } from '~/components/Instagram';
const navigation = {
  support: [{
    page: 'returns',
    href: '/returns'
  }, {
    page: 'gdpr',
    href: '/gdpr'
  }, {
    page: 'termsConditions',
    href: '/terms-conditions'
  }],
  company: [{
    page: 'about',
    href: '/o-nas'
  }, {
    page: 'contact',
    href: '/kontakt'
  }]
};
export default function Footer({
  collections
}) {
  _s();
  const {
    t
  } = useTranslation();
  return <>
      <Instagram />
      <footer className="bg-gold2" aria-labelledby="footer-heading">
        <h2 id="footer-heading" className="sr-only">
          {t('footer.title')}
        </h2>
        <div className="max-w-7xl mx-auto pt-14 lg:pt-20 px-6 pb-10">
          <div className="xl:grid xl:grid-cols-3 xl:gap-6">
            <div className="flex flex-col md:flex-row md:gap-24 xl:col-span-2 pr-0 xl:pr-10">
              <div>
                <h3 className="text-sm font-semibold text-gold1 tracking-wider uppercase">
                  {t('footer.shop')}
                </h3>
                <ul role="list" className="mt-4 space-y-4">
                  {collections.map(collection => <li key={collection.id}>
                      <Link className="text-base text-black hover:text-gold1" to={'/collections/' + collection.slug} prefetch="intent" key={collection.id}>
                        {collection.name}
                      </Link>
                    </li>)}
                </ul>
              </div>
              <div className="mt-12 md:mt-0">
                <h3 className="text-sm font-semibold text-gold1 tracking-wider uppercase">
                  {t('footer.support')}
                </h3>
                <ul role="list" className="mt-4 space-y-4">
                  {navigation.support.map(({
                  page,
                  href
                }) => <li key={page}>
                      <a href={href} className="text-base text-black hover:text-gold1">
                        {t(`navigation.support.${page}`)}
                      </a>
                    </li>)}
                </ul>
              </div>
              <div className="mt-12 md:mt-0">
                <h3 className="text-sm font-semibold text-gold1 tracking-wider uppercase">
                  {t('navigation.company.name')}
                </h3>
                <ul role="list" className="mt-4 space-y-4">
                  {navigation.company.map(({
                  page,
                  href
                }) => <li key={page}>
                      <a href={href} className="text-base text-black hover:text-gold1">
                        {t(`navigation.company.${page}`)}
                      </a>
                    </li>)}
                </ul>
              </div>
            </div>
            <div className="mt-8 xl:mt-0">
              <h3 className="text-sm font-semibold text-gold1 tracking-wider uppercase">
                {t('footer.subscribeHeader')}
              </h3>
              <p className="mt-4 text-base text-black">
                {t('footer.subscribeIntro')}
              </p>
              <form className="mt-4 sm:flex sm:max-w-md">
                <label htmlFor="email-address" className="sr-only">
                  {t('acount.emailAddress')}
                </label>
                <input type="email" name="email-address" id="email-address" autoComplete="email" required className="appearance-none min-w-0 w-full backdrop-blur-md border-0 rounded-md py-2 px-4 text-base text-black placeholder-black focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white focus:border-white focus:placeholder-gray-400" placeholder={t('footer.emailPlaceholder')} style={{
                background: `
                    linear-gradient(0deg, rgba(0, 0, 0, 0.06) 0%, rgba(0, 0, 0, 0.06) 100%),
                    rgba(255, 255, 255, 0.10)
                  `
              }} />
                <div className="mt-3 rounded-md sm:mt-0 sm:ml-3 sm:flex-shrink-0">
                  <button type="submit" className="w-full bg-primary-500 border border-transparent rounded-md py-2 px-4 flex items-center justify-center text-base font-medium text-white hover:bg-primary-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-primary-500">
                    {t('footer.subscribe')}
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div className="mt-10 border-t border-white pt-10 text-black flex justify-start items-center gap-4">
            <img src="/logo-footer.svg" width={32} height={37} alt={t('commmon.logoAlt')} />

            {t('footer.text')}

            <a href="https://www.instagram.com/lahudkyzlatykrizpraha/" target="_blank" rel="noopener noreferrer" className="ml-auto text-black hover:text-gold1 flex items-center gap-2">
              <span className="text-sm">@zlatykrizlahudky</span>
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" />
              </svg>
            </a>
          </div>
        </div>
      </footer>
    </>;
}
_s(Footer, "zlIdU9EjM2llFt74AbE2KsUJXyM=", false, function () {
  return [useTranslation];
});
_c = Footer;
var _c;
$RefreshReg$(_c, "Footer");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;